var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingExam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 19.999,
    viewBox: "0 0 25 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#053067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.081-2.866a1.436,1.436,0,0,0,.884.366h1.66a.625.625,0,0,0,.625-.625V-4.784a1.436,1.436,0,0,0-.366-.884l-9.04-9.041-2.8,2.8ZM8.159-12.788l2.8-2.8L9.328-17.227a1.082,1.082,0,0,0-.662-.272A1.082,1.082,0,0,0,8-17.227l-1.48,1.479a1.077,1.077,0,0,0-.272.66,1.077,1.077,0,0,0,.272.66ZM23.75-11.25H17.07l4.7,4.7A2.871,2.871,0,0,1,22.5-4.784h0v2.909a.625.625,0,0,1-.625.625H4.063a.313.313,0,0,1-.312-.312v-.625A.313.313,0,0,1,4.063-2.5H16.68L14.18-5H4.063a.313.313,0,0,1-.312-.312v-.625a.313.313,0,0,1,.313-.312H12.93l-5-5H1.25A1.25,1.25,0,0,0,0-10V1.25A1.25,1.25,0,0,0,1.25,2.5h22.5A1.25,1.25,0,0,0,25,1.25V-10A1.25,1.25,0,0,0,23.75-11.25Z",
    transform: "translate(0 17.499)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingExam);
export default __webpack_public_path__ + "static/media/upcoming_exam.2e163f3276911a10eb17b8ef97658efe.svg";
export { ForwardRef as ReactComponent };